import { getMetrics } from '../metrics'
import { EventTypes } from '../middleware/ActionTypes'
import { IFunnelTrackingData } from './models/IFunnelTrackingData'
import { getFunnelRequiredDetails } from './utils'

import { AppState } from '../../data/state'
import { store } from '../../store/store'
import { IGoogleData } from './models/IGoogleData'

export function addToCart() {
  const metrics = getMetrics()
  Promise.resolve(
    metrics.api.track(EventTypes.ADD_TO_CART, getAddToCartDetails()),
  ).catch(e => console.error(`Metrics failed because: ${e}`))
}

function getAddToCartDetails(): IFunnelTrackingData {
  const state: AppState = Object.assign({}, store.getState())

  return getFunnelRequiredDetails(state)
}

export function FacebookAddToCart(data: IFunnelTrackingData): any {
  return {
    value: data.total_value,
    currency: data.currency,
    content_id: data.trip_id,
    content_name: data.trip_type,
    content_category: data.category,
    trip_type: data.trip_type,
    departure_date: data.departure_date,
    people: data.people,
    adults: data.adults,
    children: data.children,
    babies: data.babies,
    country: data.country,
  }
}

export function GoogleAddToCart(data: IFunnelTrackingData): any {
  const gData: IGoogleData = {
    items: [
      {
        id: data.trip_id,
        name: data.trip_type,
        category: data.category,
        price: data.total_value,
        quantity: 1,
        dimension1: data.trip_type,
        dimension2: data.departure_date,
        dimension3: data.people,
        dimension6: data.adults,
        dimension7: data.children,
        dimension8: data.babies,
        dimension17: data.country,
        metric1: data.people,
        metric2: data.adults,
        metric3: data.children,
        metric4: data.babies,
      },
    ],
    currency: data.currency,
  }
  if (data.items) {
    gData.items.push(...data.items)
  }
  return gData
}

export function SnapchatAddToCart(data: IFunnelTrackingData): any {
  return {
    price: data.total_value,
    currency: data.currency,
    item_ids: [data.trip_id],
    item_category: data.category,
  }
}
